export enum FormStateYesNo {
  Yes = 'Yes',
  No = 'No'
}
